<template>
  <div>
    <v-row>
      <v-col class="text-center">
        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">Route Instructions</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <ckeditor
                      :editor="editor"
                      v-model="instructions"
                      :config="editorConfig"
                    ></ckeditor>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close()">Close</v-btn>
              <v-btn color="blue darken-1" text @click="add()">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2";

import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";

import EssentialsPlugin from "@ckeditor/ckeditor5-essentials/src/essentials";
import BoldPlugin from "@ckeditor/ckeditor5-basic-styles/src/bold";
import ItalicPlugin from "@ckeditor/ckeditor5-basic-styles/src/italic";
import ParagraphPlugin from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import ListPlugin from "@ckeditor/ckeditor5-list/src/list";
import ChecklistPlugin from "@ckeditor/ckeditor5-list/src/todolist";

export default {
  name: "addReceiverInstructions",
  props: {
    dialog: Boolean,
    receiver: Object,
  },
  data() {
    return {
      instructions: "",
      errorMessage: null,
      editor: ClassicEditor,
      editorConfig: {
        plugins: [
          EssentialsPlugin,
          BoldPlugin,
          ItalicPlugin,
          ParagraphPlugin,
          ListPlugin,
          ChecklistPlugin,
        ],
        toolbar: {
          items: [
            "bold",
            "italic",
            "undo",
            "redo",
            "numberedList",
            "bulletedList",
            "list",
          ],
        },
      },
    };
  },
  methods: {
    ...mapActions([
      "addUser",
      "removeUser",
      "fetchUsers",
      "fetchActions",
      "addNewReceiver",
      "addSubRoute",
      "updateAddedReceiver",
      "addReceiverInstructions"
    ]),
    close() {
      this.instructions = "";
      this.$emit("closeDialog", false);
    },
    async add() {
      this.errorMessage = null;
      // if (!this.validateName()) return false;

      let body = {
        instructions: this.instructions,
        receiver: this.receiver,
      };

      this.addReceiverInstructions(body).then(() => {
        Swal.fire("Saved!", "Instructions added", "success");
        this.close();
      });
    },
  },
  computed: mapGetters([
    "getAssignedUsers",
    "getUnassignedUsers",
    "allUsers",
    "allActions",
  ]),
  watch: {
    dialog: function() {
      if (this.dialog) {
        if (this.receiver.instructions) this.instructions = this.receiver.instructions
      }
    },
  },
};
</script>

<style></style>
